import { render, staticRenderFns } from "./SkeletonCardProduct.vue?vue&type=template&id=4d59445a"
var script = {}
import style0 from "./SkeletonCardProduct.vue?vue&type=style&index=0&id=4d59445a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports